var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-card',{attrs:{"items":_vm.sections,"md":12,"sm":12,"lg":12,"xl":12,"height":3}})}
var staticRenderFns = []

export { render, staticRenderFns }